import { createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/terotechDataservice';

const initialState = {
  notifications: [],
  status: 'Status iniziale',
  machine: 
  {
    "machineType":    0, 
    "machineCode":    "",
    "machineDesc":    "",
    "machineSup":     "",
    "machineSAPCode": "",
    "machineYear":    "",
    "machineDistC":   "",
    "machineDistL":   "",
    "machineCostBD":  "",
    "machineSpareN":  "",
    "machineClassCd": "",
    "machineClassRea":"",
    "machineClassPre":"",
    "machinePrice":"",
    "machineNoteGeneral":"",
    "machineNoteSecurity":"",
    "machineImage":""
  },
  machineExt: //dati extra per scale + brache-funi-catene (plant3)
  {
    "machineExtId": 0,
    "machineExtIdMachine": 0, 
    "machineExtStairType": 0,
    "machineExtSurfaceLength": 0,
    "machineExtSurfaceWidth": 0,
    "machineExtStairTreadWidth": 0,
    "machineExtWheelsNo": 0,
    "machineExtAdjustableStab": "",
    "machineExtStabNo": 0,
    "machineExtLoadCapacityKgB3": "",
    "machineExtLanding": "",
  },
};

const slice1 = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    getNotifications(state, action) {
      const { notifications } = action.payload;

      state.notifications = notifications;
    }
  }
});
export const reducer1 = slice1.reducer;

const slice2 = createSlice({
  name: 'machine',
  initialState,
  reducers: {
    getMachine(state, action) {
      state.status = 'getMachine';
      state.machine =   {
        "idMachine":    action.payload.id, 
        "machineType":    action.payload.idtipology, 
        "machineCode":    action.payload.code,
        "machineDesc":    action.payload.description,
        "machineSup":     action.payload.idsupplier,
        "machineSAPCode": action.payload.codeSap,
        "machineYear":    action.payload.yearSetup,
        "machineDistC":   action.payload.distCentralWarehouse || "0",
        "machineDistL":   action.payload.distLubrificantWarehouse || "0",
        "machineCostBD":  "",
        "machineSpareN":  "",
        "machineClassCd": action.payload.classCd,
        "machineClassRea":action.payload.classRea,
        "machineClassPre":action.payload.classPro,
        "machinePrice":action.payload.price,
        "machineNoteGeneral":action.payload.noteGeneral,
        "machineNoteSecurity":action.payload.noteSecurity,
        "machineOperation":action.payload.idoperazione,
        "machineImage": action.payload.fileImg
      }
    },
    updateMachine(state, action) {
      state.status = 'updateMachine'; 
      state.machine.idMachine = action.payload.id|| state.machine.idMachine;
      state.machine.machineType = action.payload.idtipology|| state.machine.machineType;
      state.machine.machineCode = action.payload.code || state.machine.machineCode;
      state.machine.machineDesc = action.payload.description || state.machine.machineDesc;
      state.machine.machineSup = action.payload.idsupplier || state.machine.machineSup;
      state.machine.machineSAPCode = action.payload.codeSap || state.machine.machineSAPCode;
      state.machine.machineYear = action.payload.yearSetup || state.machine.machineYear;
      state.machine.machineDistC = action.payload.distCentralWarehouse || state.machine.machineDistC;
      state.machine.machineDistL = action.payload.distLubrificantWarehouse || state.machine.machineDistL;
      state.machine.machineCostBD = "";
      state.machine.machineSpareN = "";
      state.machine.machineClassCd = action.payload.classCd || state.machine.machineClassCd;
      state.machine.machineClassRea = action.payload.classRea || state.machine.machineClassRea;
      state.machine.machineClassPre = action.payload.classPro || state.machine.machineClassPre;
      state.machine.machinePrice = action.payload.price || state.machine.machinePrice;
      state.machine.machineNoteGeneral = action.payload.noteGeneral || state.machine.machineNoteGeneral;
      state.machine.machineNoteSecurity = action.payload.noteSecurity || state.machine.machineNoteSecurity;
      state.machine.machineImage = action.payload.fileImg|| state.machine.machineImage;
    },
    putMachine(state, action) {
      state.status = 'putMachine'; 
      debugger
    }
  }
});
export const reducer2 = slice2.reducer;

const slice3 = createSlice({
  name: 'machineExt',
  initialState,
  reducers: {
    getMachineExt(state, action) {
      state.status = 'getMachineExt';
      state.machineExt =  {
        machineExtId: action.payload.machineExtension?.id ?? 0,
        machineExtIdMachine: action.payload.machineExtension?.idMachine ?? "",
        machineExtStairHeight: action.payload.machineExtension?.stairHeight ?? "",
        machineExtStairType: action.payload.machineExtension?.stairType ?? "",
        machineExtSurfaceLength: action.payload.machineExtension?.surfaceLength ?? "",
        machineExtSurfaceWidth: action.payload.machineExtension?.surfaceWidth ?? "",
        machineExtStairTreadWidth: action.payload.machineExtension?.stairTreadWidth ?? "",
        machineExtWheelsNo: action.payload.machineExtension?.wheelsNo ?? "",
        machineExtAdjustableStab: action.payload.machineExtension?.adjustableStab ?? "",
        machineExtStabNo: action.payload.machineExtension?.stabNo ?? "",
        machineExtLanding: action.payload.machineExtension?.landing ?? "",
        machineExtLoadCapacityKgB3: action.payload.machineExtension?.loadCapacityKgB3 ?? ""
      }
    },
    postMachineExt(state, action) {
      state.status = 'postMachineExt';

      state.machineExt = {
        ...state.machineExt,
        machineExtId: action.payload.id
      };
    },
    putMachineExt(state, action) {
      state.status = 'putMachineExt'; 
    },
    resetMachineExt(state) {
      state.machineExt = null;
    }
  }
});
export const reducer3 = slice3.reducer;

export const getNotifications = () => async (dispatch) => {
  const response = await axios.get('/api/notifications');
  dispatch(slice1.actions.getNotifications(response.data));
};

export const getMachine = (id) => async (dispatch) => {
  const response = await axios.get("/machine/items/" + id);
  dispatch(slice2.actions.getMachine( response.data )); 
};

export const updateMachine = (update) => async (dispatch) => {
  debugger
  
  dispatch(slice2.actions.updateMachine( update )); 
};

export const putMachine = (id, machinecode, machinecodesap, machinedesc, machineyear, machinetype, machinesup, machinedistc, machinedistl, machinelassCD, machineclassRea, machineprice, machinenoteGen, machinenoteSafety, machineop, machineimage) => async (dispatch) => {
  //let axios1 = require('axios');
  debugger
  const idMac = id;


  // axios1.defaults.baseURL = 'http://myurl';
 // axios.defaults.crossDomain = true;
 // axios.defaults.headers.put['Access-Control-Allow-Origin'] = '*';
 // axios.defaults.headers.put["accept"] = "*/*";
 // axios.defaults.headers.put["Content-Type"] = "application/json-patch+json";
  const response = await axios.put("/machine/items", 
  {
    id: id,
    code: machinecode,
    codeSap: machinecodesap,
    description: machinedesc,
    yearSetup: machineyear,
    idTipology: parseInt(machinetype),
    idSupplier: parseInt(machinesup),
    distWareCentral: machinedistc,
    distWareLubrif: machinedistl,
    classCD: machinelassCD,
    classREA: machineclassRea,
    classPRE: "",
    price: machineprice,
    noteGeneral: machinenoteGen,
    noteSecurity: machinenoteSafety,
    idoperazione: machineop,
    fileImg: machineimage,
    flgTwin: 0,
    


  })// "/api" + "/v1
  
  //  "{\"id\":"+ idMac+ ",\"code\":\""+code+"\",\"codeSap\":\"" + sap +"\",\"description\":\"MASCHERA AVPE\",\"yearSetup\":" + year + ",\"idTipology\":"+idMachineType+",\"idSupplier\":"+idSupplier+",\"distWareCentral\":" + distc + ",\"distWareLubrif\":" + distl + ",\"flgTwin\":0,\"fileImg\":\"plt00012/a1b89be1-cd13-4564-95ed-5fc0d5cff6a5.png\",\"classCD\":\""+classCD +"\",\"classREA\":\""+classRea +"\",\"classPRE\":\"C\",\"price\":\""+price+"\",\"noteGeneral\":\""+noteGen +"\",\"noteSecurity\":\""+noteSafety +"\"}");                              

  dispatch(slice2.actions.putMachine(response.data)); 
};

export const getMachineExt = (id) => async (dispatch) => {
  const response = await axios.get("/machine/itemsmachineextensionsplant3byid/" + id);
  dispatch(slice3.actions.getMachineExt(response.data)); 
};

export const postMachineExt = (values) => async (dispatch) => {
  const response = await axios.post("/machine/itemsmachineextensionsplant3", values);
  dispatch(slice3.actions.postMachineExt(response.data));
  return response.data; 
};

export const putMachineExt = (values) => async (dispatch) => {
  const response = await axios.put("/machine/itemsmachineextensionsplant3", values);
  dispatch(slice3.actions.putMachineExt(response.data)); 
};

export const resetMachineExt = () => async (dispatch) => {
  dispatch(slice3.actions.resetMachineExt()); 
};

export const putImage = (id, fileImg) => async (dispatch) => {
  let axios1 = require('axios');
  const idMachine = id;
  // axios1.defaults.baseURL = 'http://myurl';
  axios.defaults.crossDomain = true;
  axios.defaults.headers.put['Access-Control-Allow-Origin'] = '*';
  axios.defaults.headers.put["accept"] = "*/*";
  axios.defaults.headers.put["Content-Type"] = "multipart/form-data";
  const response = await axios1.post("/machine/image?id="+ idMachine,
  "file=@"+fileImg);
  dispatch(slice2.actions.putImage(response.data)); 
};

export {
  slice1,
  slice2,
  slice3
};
 